<template>
  <div class="md-layout">
    <help-link :link="helpLink.link"></help-link>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>show_chart</md-icon>
        </div>
        <md-toolbar class="fm-card-header">
          <h1 class="md-title">
            <span>Application:</span>
            {{ appLabel }}
          </h1>
          <app-selector
            @update-selected-app="changeMySelectedApp"
          ></app-selector>
        </md-toolbar>
      </md-card-header>
    </md-card>
    <nav-tabs-card>
      <template slot="content">
        <md-tabs
          class="md-primary"
          md-alignment="left"
          @md-changed="tabChanged"
          md-active-tab="live"
        >
          <md-tab id="live" md-label="Live" md-icon="cast_connected">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <live-sessions ref="live"></live-sessions>
              </div>
            </div>
          </md-tab>
          <md-tab
            id="24-hours"
            md-label="Previous 24 Hours"
            md-icon="access_time"
          >
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <historic-sessions
                  ref="24-hours"
                  v-bind:numberOfDays="1"
                ></historic-sessions>
              </div>
            </div>
          </md-tab>
        </md-tabs>
      </template>
    </nav-tabs-card>
  </div>
</template>
<script>
import { get } from "vuex-pathify";
import { NavTabsCard } from "@/components";
import LiveSessions from "./LiveSessionInfo.vue";
import HistoricSessions from "./HistoricSessionInfo.vue";
import { globalSelectedApp, changeSelectedApp } from "../../utils/global.js";
import { AppSelector, HelpLinkTemplate } from "@/fmComponents";
import helpLinks from "../../contextualHelpLinks.js";
import swal from "sweetalert2";

export default {
  components: { 
    NavTabsCard, 
    LiveSessions, 
    HistoricSessions, 
    AppSelector,
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.sessions,
    currentTab: "live",
    applicationId: null,
    selectedApp: null
  }),
  computed: {
    appLabel: function() {
      return this.selectedApp
        ? this.selectedApp.tag || this.selectedApp.applicationId
        : "-";
    },
    apps: get("applications/entities") || []
  },
  created() {
    var me = this;
    this.$store.dispatch("applications/loadEntities").then(() => {
      this.selectedApp = globalSelectedApp;
      if (this.selectedApp != null) {
        me.loadChannelStats(this.selectedApp.applicationId);
      } else {
        swal
          .fire({
            title: "Application Required",
            text: "An application is required to view session info.",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false,
          })
          .then(() => {
            this.$router.push({
              path: "/applications/",
            });
          });
      }
    });
  },
  methods: {
    tabChanged: function(tabId) {
      this.currentTab = tabId;
      this.loadChannelStats();
    },
    loadChannelStats: function(appId) {
      if (appId) {
        this.applicationId = appId;
      }
      if (this.applicationId) {
        this.$refs[this.currentTab].loadChannelStats(this.applicationId);
      }
    },
    changeMySelectedApp: function(newApp) {
      if (newApp != null) {
        this.selectedApp = newApp;
      } else {
        this.selectedApp = { applicationId: null };
      }
      var me = this;
      me.loadChannelStats(this.selectedApp.applicationId);
      changeSelectedApp(this.selectedApp);
    }
  }
};
</script>
<style lang="scss" scoped>
.contextual-help {
  position: absolute;
  top: 23.5px;
  left: 137px;
  z-index: 100;
}
</style>
